import React, { useState, useRef, useEffect } from 'react';
import './Work.css';
import Products from './Products';
import Projects from './Projects';

export default function Work() {
  const [activeTab, setActiveTab] = useState('products');
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash;
      if (hash === '#projects') setActiveTab('projects');
      if (hash === '#products') setActiveTab('products');
    };

    window.addEventListener('hashchange', handleHashChange);
    handleHashChange(); // Initial check

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      observer.disconnect();
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  return (
    <section id="work" className="work-section" ref={sectionRef}>
      <div id="products" className="anchor-point"></div>
      <div id="projects" className="anchor-point"></div>
      <div className="work-container">
        <div className={`work-header ${isVisible ? 'fade-in-up' : ''}`}>
          <h2 className="work-title">Featured Work</h2>
          <p className="work-subtitle">Built with passion, performance, and precision</p>
          
          <div className="tab-switcher">
            <button 
              className={`tab-btn ${activeTab === 'products' ? 'active' : ''}`}
              onClick={() => setActiveTab('products')}
            >
              Flagship Products
              {activeTab === 'products' && <span className="tab-indicator" />}
            </button>
            <button 
              className={`tab-btn ${activeTab === 'projects' ? 'active' : ''}`}
              onClick={() => setActiveTab('projects')}
            >
              Latest Projects
              {activeTab === 'projects' && <span className="tab-indicator" />}
            </button>
          </div>
        </div>

        <div className={`work-content-area ${isVisible ? 'fade-in' : ''}`}>
          {activeTab === 'products' ? (
            <Products isVisible={isVisible} />
          ) : (
            <Projects isVisible={isVisible} />
          )}
        </div>
      </div>
    </section>
  );
}
